/** The suffix a replayed saved run adds to its change set's title, to keep titles unique. */
const SAVED_RUN_SUFFIX = /\s*\(saved run [0-9a-f-]+\)$/u;

/** A change set's title as people read it: without the saved-run suffix, which names an ID. */
export function readableChangeSetTitle(title: string): string {
  return title.replace(SAVED_RUN_SUFFIX, "");
}
